import { Ionicons } from '@expo/vector-icons';
import { Text, View } from 'react-native';

import { getPasswordRequirements } from '@/lib/password-policy';

type PasswordRequirementListProps = {
  password: string;
  className?: string;
};

export function PasswordRequirementList({
  password,
  className = '',
}: PasswordRequirementListProps) {
  const requirements = getPasswordRequirements(password).filter(
    (requirement) => requirement.id !== 'maximumLength',
  );
  const accessibilityLabel = requirements
    .map((requirement) => `${requirement.label}: ${requirement.isMet ? 'met' : 'not met'}`)
    .join(', ');

  return (
    <View
      className={`w-full gap-2 ${className}`}
      accessibilityLabel={`Password requirements. ${accessibilityLabel}`}
    >
      {requirements.map((requirement) => (
        <View
          key={requirement.id}
          className="flex-row items-center gap-2"
          accessibilityLabel={`${requirement.label}: ${requirement.isMet ? 'met' : 'not met'}`}
        >
          <View
            className={`h-4 w-4 items-center justify-center rounded-full ${
              requirement.isMet ? 'bg-forest-600' : 'border border-gray-600'
            }`}
          >
            {requirement.isMet ? (
              <Ionicons name="checkmark" size={11} color="#ffffff" />
            ) : null}
          </View>
          <Text
            className={`flex-1 text-xs leading-5 ${
              requirement.isMet ? 'text-emerald-300' : 'text-gray-400'
            }`}
          >
            {requirement.label}
          </Text>
        </View>
      ))}
    </View>
  );
}
